import { IImageVariable } from "common/interfaces/image-variable.interface";
import DashboardLayout from "components/DashboardLayout/DashboardLayout";
import React, { FunctionComponent } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import * as actions from "redux/actions/image-variable.actions";
import { getImageVariableById } from "redux/selectors/image-variable.selector";
import EditImageVariableView from "views/editImageVariable/editImageVariable";

const EditImageVariable: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { id }: { id: string } = useParams();
  const getImageVariableData = useSelector(getImageVariableById(id));

  const editImageVariable = (value: IImageVariable, file: FileList) => {
    dispatch(actions.onEditImageVariable(value, file));
  };

  return (
    <DashboardLayout>
      <EditImageVariableView
        imageVariable={getImageVariableData[0]}
        editVariable={editImageVariable}
      />
    </DashboardLayout>
  );
};

export default EditImageVariable;
